$('#Stage_startDate').on('input', function () {
    $('#Stage_moveEarlierStages').closest('.form-group').removeClass('d-none');
});
$('#Stage_endDate').on('input', function () {
    $('#Stage_moveLaterStages').closest('.form-group').removeClass('d-none');
});